import {css, jsx} from '@emotion/react';
import styled from '@emotion/styled';

export const Content = styled('div')({
  marginBottom: '1.5rem',
  color: 'black',
});
